<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='700px'>
    <el-form v-loading='formLoading' :model='form' label-width='140px' label-position='right'
             ref='ruleForm'>
      <div-border label='基本信息' class='p20'>
        <el-row :gutter='10'>
          <el-col :span='12'>
            <el-form-item label='库房名称：'>
              <span>{{ form.warehouseName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='所在区域：'>
              <span>{{ form.area }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='详细地址：'>
              <span>{{ form.address }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='面积：'>
              <span>{{ form.square }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label='所属供应商：'>
              <span>{{ form.supplierName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>

      <div-border label='操作记录' class='p20'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='form.operateRecords'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
          <el-table-column prop='operateType' label='操作类型' align='center' />
          <el-table-column prop='operationName' label='操作人' align='center' />
          <el-table-column prop='remark' label='备注' align='center' />
        </el-table>
      </div-border>

      <div class='flex-center-center mt10'>
        <el-button size='medium' class='searchBtn' @click='dialogClose'>确认</el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { warehouseManagementDetail } from '@/service/warehouse';

  export default {
    name: 'warehouseManagementInfo',
    components: { divBorder },
    data() {
      return {
        dialogTitle: '详情',
        dialogVisible: false,
        defaultForm: {},
        form: {},
        tableLoading: false,
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        formLoading: false,
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(id) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.getDetails(id);
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      async getDetails(id) {
        this.formLoading = true;
        const {
          status,
          message,
          data,
        } = await warehouseManagementDetail(id);
        this.formLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form = data;
      },
    },
  };
</script>

<style lang='scss' scoped></style>
